import { useMemo } from 'react';
import get from 'lodash/get';
import { makeObjectOutOfArrays } from '../../../../../containers/Overview/utils';


const useTransformPieChartData = (item, timeperiodLabel) => {
    return useMemo(() => {
        const pieColumns = get(item, 'cstData.columns');
        const pieMetricData = get(item, 'cstData.metric_data');
        const metric_count = get(item, 'cstData.metric_count');

        const pieDataObj = makeObjectOutOfArrays(pieColumns, get(pieMetricData, '[0]'));
        const valueKeyToPlot = get(item, 'valueKeyToPlot');
        const value = get(pieDataObj, valueKeyToPlot);

        const benchmarkValue = get(pieDataObj, 'benchmark_value');
        const benchmarkSampleSize = (value - benchmarkValue)?.toFixed(2) || '0.00';
        const subLabel = `${benchmarkSampleSize > 0 ? '+' : ''}  ${benchmarkSampleSize}`;

        const itemData = get(item, 'data');
        const options = {
            ...itemData,
            centerLabel: {
                label: value,
                subLabel: subLabel
            }
        };

        const title = get(item, 'title');
        const pieChartSubtitle = `${timeperiodLabel}: ${title}`;
        const lowSampleSize = get(item, 'lowSampleSize');
        const isLowSampleSize = get(metric_count, "[0][0]", null) < lowSampleSize;

        return {
            value,
            subLabel,
            options,
            isLowSampleSize,
            lowSampleSize,
            pieChartSubtitle
        };
    }, [item, timeperiodLabel]);
};

export default useTransformPieChartData;